export default function extractQueryParams(param: string, searchString: string) {
    const regex = new RegExp("[&?]" + param + "=([^&]+).*$");
    const paramMatch = searchString.match(regex);

    const value = paramMatch ? paramMatch[1] : "";
    return value;
}